import React from "react";
import "./component.css";
import leftArrow from "../../../../assests/leftArrow.svg";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import uploadsvg from "../../../../assests/uploadsvg.svg";
import Papa from "papaparse";
import CreateCorporateComponent1 from "./CreateCorporate/component";
import AddCorporateUserComponent from "./AddUser/component";
import RechargeRuleComponent from "./RechargeRule/component";
import UsageLimitComponent from "./UsageLimit/component";

const BPCreateComponent = (props) => {
  const steps = [
    "Create Corporate",
    "Add User",
    "Recharge Rule",
    "Usage Limit",
  ];


console.log("useageLimit",props.useageLimit)

  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/");
  };

  const handleCSVFileUpload = (file) => {
    if (file) {
      Papa.parse(file, {
        complete: (result) => {
          const csvData = result.data;

          if (csvData.length > 1) {
            const uidTokenPairs = csvData.slice(1).map((row) => ({
              uid: row[0],
              token: row[1],
            }));

            props.setInputs(uidTokenPairs);
          }
        },
        header: false,
      });
    }
  };

  const renderLeftSideButton = () => {
    if (props.activeStep === 1) {
      return (
        <>
          <input
            type="file"
            accept=".csv"
            onChange={(e) => handleCSVFileUpload(e.target.files[0])}
            style={{ display: "none" }}
            id="fileInput"
          />

          <label htmlFor="fileInput">
            <Button
              variant="contained"
              component="span"
              className="bp-upload-button"
            >
              <img style={{ marginRight: "8px" }} src={uploadsvg} alt="upload" />
              Bulk Upload
            </Button>
          </label>
        </>
      );
    }
    return null;
  };

  return (
    <div className="bp-create-container">
      <Sidebar />

      <div className="bp-create-content">
        <div className="bp-create-header">
          <button onClick={handleClick} className="bp-back-button">
            <img src={leftArrow} alt="Back" />
          </button>
          <h2>Create a Corporate</h2>
        </div>

        <div className="bp-stepper-container">
          <Box sx={{ width: "100%" }}>
            <Stepper activeStep={props.activeStep}>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {renderLeftSideButton()}
          </div>
        </div>
        
        <div className="bp-form-container">
         

          <div className="bp-step-content">
            {props.activeStep === 0 && (
              <CreateCorporateComponent1
                createCorporateData={props.createCorporateData}
                handleCreateCorporate={props.handleCreateCorporate}
                handleChangeCorporate={props.handleChangeCorporate}
                setCreateCorporateData={props.setCreateCorporateData}
              />
            )}
            {props.activeStep === 1 && (
              <AddCorporateUserComponent
                createUser={props.createUser}
                setCreateUser={props.setCreateUser}
                handleChangeUser={props.handleChangeUser}
              />
            )}
            {props.activeStep === 2 && (
              <RechargeRuleComponent
                activeBtn={props.activeBtn}
                handleAddRechargeBtnClick={props.handleAddRechargeBtnClick}
                handleAddRechargeBtnClick1={props.handleAddRechargeBtnClick1}
                activeBtn1={props.activeBtn1}
                handleChangeRecharge={props.handleChangeRecharge}
                rechargeData={props.rechargeData}
                setActiveBtn={props.setActiveBtn}
                handleResetBalanceChange={props.handleResetBalanceChange}
              />
            )}
            {props.activeStep === 3 && (
              <UsageLimitComponent
                handleChangeUserLimit={props.handleChangeUserLimit}
                userLimit={props.userLimit}
                setUserLimit={props.setUserLimit}
                useageLimit={props.useageLimit}
                handleUserLimit={props.handleUserLimit}
                handleSelectChange={props.handleSelectChange}
              />
            )}
          </div>

          <div className="bp-button-group">
            <Button
              className="bp-cancel-button"
              onClick={props.handleClose}
              disabled={props.activeStep === 0}
            >
              Cancel
            </Button>
            <Button
              className="bp-save-button"
              variant="contained"
              onClick={props.handleNext}
            >
              {props.activeStep === steps.length - 1 ? "Save" : "Save and Continue"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BPCreateComponent;